import { ACTIONS } from "./type"

export const getSettingsWatcher = (payload: any) => {
    return { type: ACTIONS.GET_SETTINGS_WATCHER, payload }
}

export const getSettingsSuccess = (payload: any) => {
    return { type: ACTIONS.GET_SETTINGS_SUCCESS, payload }
}

export const getSettingsError = (payload: any) => {
    return { type: ACTIONS.GET_SETTINGS_ERROR, payload }
}

export const updateAgeState = (payload: string) => {
    return { type: ACTIONS.UPDATE_AGE_STATE, payload }
}

export const updateLoader = (payload: boolean) => {
    return { type: ACTIONS.UPDATE_LOADER, payload }
}

export const saveVote = (payload: any) => {
    return { type: ACTIONS.SAVE_VOTE, payload }
}

